module.exports = "../img/marker-map.png";